export const screenName = 'available-products';

const PUBLIC_OFFER_SORT_BY = {
  OfferingType: 'OfferingType',
  IssuerName: 'IssuerName',
  Isin: 'ISIN',
  ModifiedDate: 'ModifiedDate',
  TradingDate: 'TradingDate',
  RiskClass: 'RiskClass',
  RateLimiter: 'RateLimiter',
} as const;

export const ORDER_VALUE_TO_SORT_BY: Partial<Record<string, string>> = {
  offerType: PUBLIC_OFFER_SORT_BY.OfferingType,
  offerName: PUBLIC_OFFER_SORT_BY.IssuerName,
  isinCode: PUBLIC_OFFER_SORT_BY.Isin,
  alterationDateNormalized: PUBLIC_OFFER_SORT_BY.ModifiedDate,
  negotiationDateNormalized: PUBLIC_OFFER_SORT_BY.TradingDate,
  suitabilityProfile: PUBLIC_OFFER_SORT_BY.RiskClass,
  limiter: PUBLIC_OFFER_SORT_BY.RateLimiter,
};

const PRIVATE_PENSION_ORDER_VALUE_TO_API: Partial<Record<string, string>> = {
  productNameNormalized: 'fundName',
  productTypeNormalized: 'fundTypeDescription',
  monthlyRentabilityNormalized: 'profitabilityMonthly',
  annualRentabilityNormalized: 'profitabilityYearly',
  twelveMonthsRentabilityNormalized: 'profitability12Months',
  minimumApplicationNormalized: 'minimumApplication',
  initialDateTime: 'fundStartDate',
  referenceDateTime: 'profitabilityReferenceDate',
};

export const fixOrderFieldPrivatePension = (value: string): string =>
  PRIVATE_PENSION_ORDER_VALUE_TO_API[value] ?? value;

const FUNDS_ORDER_VALUE_TO_API: Partial<Record<string, string>> = {
  profitabilityTwelveMonthsNormalized: 'profitabilityTwelveMonths',
};

export const fixOrderFieldFunds = (value: string): string =>
  FUNDS_ORDER_VALUE_TO_API[value] ?? value;
